import { InMemoryEntityModel } from "../../entity-model/in-memory-entity-model.js";
import { LOCAL_SEMANTIC_MODEL } from "../../model/known-models.js";
import { WritableSemanticModelAdapter } from "../writable-semantic-model-adapter.js";
/**
 * @deprecated Use model store instead to manage the model state.
 */
export class InMemorySemanticModel extends WritableSemanticModelAdapter {
    baseIri = "";
    modelMetadata = {};
    constructor() {
        super(new InMemoryEntityModel());
    }
    getBaseIri() {
        return this.baseIri;
    }
    setBaseIri(iri) {
        this.baseIri = iri;
    }
    serializeModel() {
        return {
            type: LOCAL_SEMANTIC_MODEL,
            ...this.modelMetadata,
            modelId: this.getId(),
            modelAlias: this.getAlias(),
            baseIri: this.baseIri ?? "",
            entities: this.entityModel.entities,
        };
    }
    deserializeModel(data) {
        const modelDescriptor = { ...data };
        this.baseIri = modelDescriptor.baseIri;
        delete modelDescriptor.baseIri;
        this.entityModel.id = modelDescriptor.modelId;
        delete modelDescriptor.modelId;
        this.entityModel.alias = modelDescriptor.modelAlias;
        delete modelDescriptor.modelAlias;
        this.entityModel.entities = modelDescriptor.entities;
        delete modelDescriptor.entities;
        this.modelMetadata = modelDescriptor;
        return this;
    }
}
//# sourceMappingURL=in-memory-semantic-model.js.map